// Constants
import { MODAL_QUERY_PARAMS } from '@/common/constants';

export const DEFAULT_BACK_LINK = '/pricing';
const PERSIST_CART_PARAM = 'persist_cart';
const PARAMS_TO_REMOVE = ['_', PERSIST_CART_PARAM, ...MODAL_QUERY_PARAMS];
const OPC_BUY_PATH = '/opc/buy';
const OPC_CHECKOUT_PATH = '/opc/buy/checkout';

/**
 * Format request link with persist_cart parameter and optional domain redirect
 * @param {string} link - The original link to format
 * @param {string} redirectDomain - Optional domain to redirect to
 * @returns {string} Formatted URL string or default back link
 */
export const formatRequestLink = (link = '', redirectDomain = '') => {
  try {
    if (!link) {
      return DEFAULT_BACK_LINK;
    }

    // Handle relative URLs by prepending current origin
    const absoluteLink = link.startsWith('http') ? link : `${window.location.origin}${link}`;
    const urlObj = new URL(absoluteLink);

    // Remove unwanted parameters
    PARAMS_TO_REMOVE.forEach((param) => {
      urlObj.searchParams.delete(param);
    });

    // Add persist_cart parameter
    urlObj.searchParams.set(PERSIST_CART_PARAM, 'true');

    // Apply domain redirect if specified
    if (redirectDomain) {
      urlObj.protocol = 'https:';
      urlObj.hostname = redirectDomain;
    }

    return urlObj.toString();
  } catch (error) {
    console.error('[formatRequestLink] Invalid URL:', link, error);
    return DEFAULT_BACK_LINK;
  }
};

/**
 * Check if current hostname is a zoom.com domain
 * @returns {boolean} True if hostname ends with 'zoom.com'
 */
export const isComDomainForHomePage = () => {
  return window.location.hostname.endsWith('zoom.com');
};

/**
 * Check if current page is an OPC product configuration page (excluding checkout)
 * @returns {boolean} True if on OPC buy page but not checkout
 */
export const isForOpcConfigProductPage = () => {
  const { pathname } = window.location;
  return pathname.includes(OPC_BUY_PATH) && pathname !== OPC_CHECKOUT_PATH;
};

/**
 * Check if current page is the checkout page
 * @returns {boolean} True if pathname is '/opc/buy/checkout'
 */
export const isCheckoutPage = () => {
  return window.location.pathname === OPC_CHECKOUT_PATH;
};
